<script setup lang="ts">
import type { AccordionTriggerPropsExtended } from '.';
import { AccordionHeader, AccordionTrigger } from 'radix-vue';
import { cn } from '@/utils';

const props = withDefaults(defineProps<AccordionTriggerPropsExtended>(), {
	accordionHeaderAs: 'h4'
});

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});
</script>

<template>
	<AccordionHeader class="flex" :as="accordionHeaderAs">
		<AccordionTrigger
			v-bind="delegatedProps"
			:class="
				cn(
					'flex flex-1 cursor-pointer items-center justify-between py-4 text-sm font-medium transition-all [&[data-state=open]>svg]:rotate-180',
					props.class
				)
			"
		>
			<slot />
			<slot name="icon">
				<IconMaterialSymbolsLightExpandMore
					class="size-6 shrink-0 text-primary transition-transform duration-200"
				/>
			</slot>
		</AccordionTrigger>
	</AccordionHeader>
</template>
